import { Component, Input, OnInit } from '@angular/core';
import { PreloadImgComponent } from 'app/core/directives/preload-img/preload-img.component';
import { TYPE_SECTIONS } from 'app/core/models/constans.model';

import { ActivatedRoute } from '@angular/router';
import { Menu, SectionMenu } from '../../models/menu.model';
import { MenuService } from '../../services/menu.service';

@Component({
    selector: 'app-menu-list-buttons',
    templateUrl: './menu-list-buttons.component.html',
    styleUrls: ['./menu-list-buttons.component.scss'],
    standalone: false
})
export class MenuListButtonsComponent extends PreloadImgComponent implements OnInit {
  /**
   * Informacion del menu seleccionado
   */
  @Input() menu: Menu = {} as Menu;
  selectedSection: SectionMenu | undefined = undefined;
  /**
   * Indica el idioma seleccionado
   */
  language: string | undefined;
  /**
   * Tipos de secciones
   */
  readonly TYPE_SECTIONS = TYPE_SECTIONS;
  constructor(
    private menuService: MenuService,
    private route: ActivatedRoute

  ) {
    super();
  }

  ngOnInit(): void {
    this.menuService.language$.subscribe((lang: string) => {
      this.language = lang;
    });
    if (this.route.snapshot.params.section) {
      this.goToSection();
    }
    setTimeout(() => {
      console.log(this.menu);
    }, 3000);
  }

  /**
   * Detecta que seleccion fue seleccionada
   * para visualizar sus items
   *
   * @param section seccion seleccionada
   */
  selectSection(section: SectionMenu) {
    if (this.selectedSection !== section) {
      this.selectedSection = section;
      this.filterSection(section);
    } else {
      this.selectedSection = undefined;
    }

  }


  /**
   * Navega la pagina hasta el contenido de la seccion
   * seleccionada
   *
   * @param section seccion a filtrar
   */
  filterSection(section: SectionMenu): void {
    setTimeout(() => {
      const sectionSelect = document.getElementById(section.name + 'section');
      if (sectionSelect) {
        sectionSelect.scrollIntoView({ block: 'start', behavior: 'smooth' });
      }
    }, 200);
  }

  /**
   * Navega a la seccion seleccionada
   */
  private goToSection() {
    this.selectedSection = this.menu.sections[parseInt(this.route.snapshot.params.section, 10)];
    setTimeout(() => {
      this.filterSection(this.menu.sections[parseInt(this.route.snapshot.params.section, 10)]);
    }, 3000);
  }

}
